import React, { memo, useEffect, useState } from "react";
import LanguageContext from "../../../helper/LanguageContext";
import { BASE_URL } from "../../../helper/constants";
import { BsCheck, BsX } from "react-icons/bs";
import { callAPI } from "../../../helper/apiUtils";
import { convertPosition } from "../../../helper/convertor";
import { ListGroup, Modal } from 'react-bootstrap';
import { Positions } from "../../../Languages/vars/Positions";
import { $crud } from "../../../helper/CrudFactory";
import { $user } from "../../../helper/UserFactory";
import { connect } from "react-redux";
import { store, UPDATE_PROJECT_ACTION_FIRE } from "../../../store";
import { withRouter } from "react-router-dom";
import UserAvatar from "../../../components/UserAvatar";
import "./ApproveUsers.css";

function ApproveUsers({ handleClose, companyRequests }) {
    const { isGerm, strings } = React.useContext(LanguageContext)
    const [users, setUsers] = useState([])
    const [Myusers, setMyUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [isShowCompany, setIsShowCompany] = useState(null)
    const [isShowME, setIsShowME] = useState(null)
    const [employeePosition, setEmployeePosition] = useState();
    const user = $user.get();
    useEffect(() => {

        //if Some one want to join the company (i am as emplyee/admin can allow him/her)
        let req = companyRequests.filter(e => {
            if (e.companyUser){
                if(e.companyUser.includes(user.id)){
                    return true
                }
            }
        })
    
        //If someone invited me in to the company
        let forME = companyRequests.filter(e => (!e.isRequest && e.userId == user?.id))

        setUsers(req)
        setMyUsers(forME)
        if (forME.length > 0) {
            setIsShowCompany(false)
            setIsShowME(true)
        }
        else if (req.length > 0) {
            setIsShowCompany(true)
            setIsShowME(false)
        }
    }, [companyRequests])

    const confirmUser = async (user) => {
        hideConfirmDia()
        const { data } = await callAPI(`/company/request/${user?.id}/confirmById?ownerBy=${user.userDegination ? true : false}&lang=${isGerm ? 'de' : 'en'}`, {
            id: user?.id
        }, 'GET');
        $crud.notify({
            type: data.status ? "success" : "error",
            message: data.message,
        });
        if (isShowCompany) {
            const updatedUsers = users.filter(u => u.id !== user?.id);
            setUsers(updatedUsers);
        }
        else if (isShowME) {
            const updatedUsers = Myusers.filter(u => u.id !== user?.id);
            setMyUsers(updatedUsers);
        }
        setSelectedUser(null)
        store.dispatch({
            type: UPDATE_PROJECT_ACTION_FIRE,
            updateProjectActionFire: true,
        });
        // if (updatedUsers.length < 1) {
        //     handleClose();
        // }
    }
    const removeUser = async (user) => {
        hideConfirmDia()
        const { data } = await callAPI(`/company/${user?.id}/deleteCompanyRequest`, {}, 'DELETE');
        $crud.notify({
            type: data.status ? "success" : "error",
            message: data.message,
        });
        if (isShowCompany) {
            const updatedUsers = users.filter(u => u.id !== user?.id);
            setUsers(updatedUsers);
        }
        else if (isShowME) {
            const updatedUsers = Myusers.filter(u => u.id !== user?.id);
            setMyUsers(updatedUsers);
        }
        setSelectedUser(null)
        store.dispatch({
            type: UPDATE_PROJECT_ACTION_FIRE,
            updateProjectActionFire: true,
        });
        // if (updatedUsers.length < 1) {
        //     handleClose();
        // }
    }
    const [showPositionDialog, setPositionDialog] = useState(false);
    const hidePositionDialog = () => setPositionDialog(false);
    const [showConfirmDia, setConfirmDia] = useState(false);
    const hideConfirmDia = () => setConfirmDia(false);

    const handleSubmit = async (type) => {
        if (type == 'reject') {
            removeUser(selectedUser)
        }
        else {
            confirmUser(selectedUser)
        }
    }

    const onConfirmClick = (user) => {
        setEmployeePosition(null)
        setSelectedUser(user)
        confirmUser(user)
        // setPositionDialog(true)
    }

    const onRejectClick = (user) => {
        setEmployeePosition(null)
        setSelectedUser(user)
        setConfirmDia(true)
    }

    const handleCloseX = () => {
        setIsShowCompany(false)
        if (Myusers.length > 0) {
            setIsShowME(true)
        }
    }

    const handleCloseXX = () => {
        setIsShowME(false)
        if (users.length > 0) {
            setIsShowCompany(true)
        }
    }

console.log('users==>', companyRequests)
    return (
        <>
            {users.length > 0 && isShowCompany &&
                <div className="backdrop approve-users">
                    <div className="role_popup shadow-sm approve-users__popup">
                        <div className="approve-users__header">
                            <h4 className="approve-users__title">
                                {strings.request_to_join_a_company}
                            </h4>
                        </div>
                        <div className="role_data approve-users__list">
                            {
                                users.map((user, index) => (
                                    <div 
                                        key={index}
                                        className={`approve-users__row${index < users.length - 1 ? '' : ' approve-users__row--last'}`}
                                    >
                                        <div className="approve-users__avatar">
                                            <UserAvatar
                                                width={35}
                                                height={35}
                                                src={user.img ? BASE_URL + user.img : null}
                                                alt={user.name}
                                                fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                                isKjuup={user.isKjuup || user.companies?.some(c => c.isKjuup)}
                                            />
                                        </div>
                                        <div className="approve-users__text">
                                            {!user.department ?
                                                <>
                                                    <span><strong className="approve-users__strong">{user.name}</strong> {strings.wants_to_join_the_company} <strong className="approve-users__strong">{user.companyName}</strong>{isGerm ? " beitreten." : "."}</span>
                                                </>
                                                :
                                                <span className="approve-users__strong">
                                                    {strings.want_to_join_dep.replace('Username', user.name).replace('depname', user.location?`${user.department}/${user.location}`:`${user.department}`).replace('companyname', user.companyName)}
                                                </span>
                                            }
                                        </div>
                                        <div className="approve-users__actions">
                                            <button
                                                onClick={e => confirmUser(user)}
                                                aria-label="Accept Request"
                                                type="button"
                                                className="kj-btn kj-btn--icon kj-btn--lg kj-btn--internal"
                                            >
                                                <BsCheck size={20} />
                                            </button>
                                            <button
                                                onClick={e => onRejectClick(user)}
                                                aria-label="Reject Request"
                                                type="button"
                                                className="kj-btn kj-btn--icon kj-btn--lg kj-btn--danger"
                                            >
                                                <BsX size={18} />
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="approve-users__footer">
                            <button
                                type="button"
                                onClick={handleCloseX}
                                className="kj-btn kj-btn--ghost kj-btn--neutral"
                            >
                                {strings.close}
                            </button>
                        </div>
                    </div>
                    <Modal
                        show={showConfirmDia}
                        onHide={hideConfirmDia}
                        animation={false}
                        dialogClassName="confirm-modal-dialog"
                        className="confirm-modal"
                        centered
                    >
                        <Modal.Body className="approve-users__confirm-body">
                            <p className="approve-users__confirm-text">
                                {strings.refuse_companyX}
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="approve-users__confirm-footer">
                            <button type="button" className="kj-btn kj-btn--outline" onClick={hideConfirmDia}>
                                {strings.cancel}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline"
                                onClick={() => handleSubmit('reject')}
                            >
                                Ok
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
            {Myusers.length > 0 && isShowME &&
                <div className="backdrop approve-users">
                    <div className="role_popup shadow-sm approve-users__popup">
                        <div className="approve-users__header">
                            <h4 className="approve-users__title">
                                {strings.c_inv}
                            </h4>
                        </div>
                        <div className="role_data approve-users__list">
                            {
                                Myusers.map((user, index) => (
                                    <div 
                                        key={index}
                                        className={`approve-users__row${index < Myusers.length - 1 ? '' : ' approve-users__row--last'}`}
                                    >
                                        <div className="approve-users__avatar">
                                            <UserAvatar
                                                width={35}
                                                height={35}
                                                src={user.img ? BASE_URL + user.img : null}
                                                alt={user.name}
                                                fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                                isKjuup={user.isKjuup || user.companies?.some(c => c.isKjuup)}
                                            />
                                        </div>
                                        <div className="approve-users__text">
                                            {!user.department ?
                                                <>
                                                    <span>{strings.invited_o_Company} <strong className="approve-users__strong">{user.companyName}</strong>{isGerm ? " eingeladen." : "."}</span>
                                                </>
                                                :
                                                <span className="approve-users__strong">
                                                    {strings.you_invited.replace('Username', user.name).replace('depname', user.location?`${user.department}/${user.location}`:`${user.department}`).replace('companyname', user.companyName)}
                                                </span>
                                            }
                                        </div>
                                        <div className="approve-users__actions">
                                            <button
                                                onClick={e => onConfirmClick(user)}
                                                aria-label="Accept Request"
                                                type="button"
                                                className="kj-btn kj-btn--icon kj-btn--lg kj-btn--internal"
                                            >
                                                <BsCheck size={20} />
                                            </button>
                                            <button
                                                onClick={e => onRejectClick(user)}
                                                aria-label="Reject Request"
                                                type="button"
                                                className="kj-btn kj-btn--icon kj-btn--lg kj-btn--danger"
                                            >
                                                <BsX size={18} />
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="approve-users__footer">
                            <button
                                type="button"
                                onClick={handleCloseXX}
                                className="kj-btn kj-btn--ghost kj-btn--neutral"
                            >
                                {strings.close}
                            </button>
                        </div>
                    </div>
                    <Modal
                        show={showPositionDialog}
                        onHide={hidePositionDialog}
                        animation={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{strings.your_position_within_company}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ListGroup variant="flush">
                                {Positions.map((position) => (
                                    <div
                                        onClick={(e) => setEmployeePosition(position.name_en)}
                                        key={position.id}
                                        className="form-check p"
                                    >
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="exampleRadios"
                                            id={position.id}
                                            value={position.name_en}
                                        />
                                        <label
                                            className="form-check-label pointer"
                                            htmlFor={position.id}
                                        >
                                            {isGerm ? position.name_de : position.name_en}
                                        </label>
                                    </div>
                                ))}
                            </ListGroup>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="kj-btn kj-btn--outline" onClick={() => {
                                setConfirmDia(true)
                            }}>
                                {strings.close_modal}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline"
                                onClick={handleSubmit}
                            >
                                Ok
                            </button>
                        </Modal.Footer>
                    </Modal>

                    <Modal
                        show={showConfirmDia}
                        onHide={hideConfirmDia}
                        animation={false}
                        dialogClassName="confirm-modal-dialog"
                        className="confirm-modal"
                        centered
                    >
                        <Modal.Body className="approve-users__confirm-body">
                            <p className="approve-users__confirm-text">
                                {strings.refuse_company}
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="approve-users__confirm-footer">
                            <button type="button" className="kj-btn kj-btn--outline" onClick={hideConfirmDia}>
                                {strings.cancel}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline"
                                onClick={() => handleSubmit('reject')}
                            >
                                Ok
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </>

    )
}

const mapStateToProps = (state) => {
    const {
        openProjects,
        updateProjectActionFire,
        projects,
        groupChats,
        forwardGroupMessages,
        draftMessages,
        updateGroupMessage,
        isOpenByOwner,
    } = state;
    return {
        projects: projects,
        openProjects: openProjects,
        updateProjectActionFire: updateProjectActionFire,
        groupChats: groupChats,
        forwardGroupMessages: forwardGroupMessages,
        draftMessages: draftMessages,
        updateGroupMessage: updateGroupMessage,
        isOpenByOwner,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateProjectAction: (value) =>
            dispatch({
                type: UPDATE_PROJECT_ACTION_FIRE,
                updateProjectActionFire: value,
            }),

    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(memo(ApproveUsers)));